export enum StreamReferenceProcessStatus {
  NotProcessed = 'NotProcessed',
  PendingDelete = 'PendingDelete',
  Processed = 'Processed',
}